import React from 'react';
import {t} from 'ttag';
import {useField} from 'formik';

import {Toggle} from '../../../../../../form/form.jsx';
import {useConnectionContext} from '../../../../connection-context.js';
import {useSettingsContext} from '../../../settings-context.js';
import Wrapper from '../../../../../../wrapper/wrapper.jsx';

const CallNotifications = () => {
  const {setIsAlertOpen} = useSettingsContext();
  const {connection} = useConnectionContext();

  const [field, , helpers] = useField('call_notifications');

  return (
    <Wrapper alignItems="center">
      <Toggle
        isChecked={connection.is_limited ? false : field.value}
        isDisabled={connection.is_limited}
        label={t`Call notifications`}
        onChange={helpers.setValue}
        onClick={() => connection.is_limited && setIsAlertOpen(true)}
      />
    </Wrapper>
  );
};

export default CallNotifications;
